import React from 'react';
import './Icons.less';

export const CoinDollar = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="size">
    <title>{'coin-dollar'}</title><path className="cls-1" d="M8,32a17.72,17.72,0,0,1-1.36-1.53A17.19,17.19,0,0,0,30.49,6.62,16.4,16.4,0,0,1,32,8,17,17,0,0,1,8,32Z"/>
    <g id="Money-Payments-Finance_Currencies_currency-dollar-circle" data-name="Money-Payments-Finance / Currencies / currency-dollar-circle">
      <g id="Group_65" data-name="Group 65">
        <g id="currency-dollar-circle">
          <path id="Oval_19" data-name="Oval 19" className="cls-2" d="M20,37A17,17,0,1,0,3,20,17,17,0,0,0,20,37Z"/><path id="Shape_449" data-name="Shape 449" className="cls-2" d="M24.86,12.71H18a2.69,2.69,0,0,0-2.9,2.9c0,3.18,9.72,5.6,9.72,8.78a2.87,2.87,0,0,1-2.9,2.9H15.14"/><path id="Shape_450" data-name="Shape 450" className="cls-2" d="M20,12.71V9.07"/>
          <path id="Shape_451" data-name="Shape 451" className="cls-2" d="M20,30.93V27.29"/>
        </g>
      </g>
    </g>
  </svg>
);

export const CoinPound = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="size">
    <title>{'coin-pound'}</title>
    <path className="cls-1" d="M8,32a17.72,17.72,0,0,1-1.36-1.53A17.19,17.19,0,0,0,30.49,6.62,16.4,16.4,0,0,1,32,8,17,17,0,0,1,8,32Z"/>
    <g id="Money-Payments-Finance_Currencies_currency-pound-circle" data-name="Money-Payments-Finance / Currencies / currency-pound-circle">
      <g id="Group_81" data-name="Group 81">
        <g id="currency-pound-circle">
          <path id="Oval_25" data-name="Oval 25" className="cls-2" d="M20,37A17,17,0,1,0,3,20,17,17,0,0,0,20,37Z"/>
          <path id="Shape_530" data-name="Shape 530" className="cls-2" d="M24.86,13.93a3.65,3.65,0,0,0-7.29,0V24.86a2.43,2.43,0,0,1-2.43,2.43h9.72"/><path id="Shape_531" data-name="Shape 531" className="cls-2" d="M15.14,20h7.29"/>
        </g>
      </g>
    </g>
  </svg>
);

export const LockShield = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="size">
    <title>{'lock-shield'}</title>
    <path className="cls-1" d="M20,16.6h4.53a2.27,2.27,0,0,1,2.27,2.27V25a2.27,2.27,0,0,1-2.27,2.27H20a0,0,0,0,1,0,0V16.6A0,0,0,0,1,20,16.6Z"/>
    <g id="Programming-Apps-Websites_Bug_Security_shield-lock" data-name="Programming-Apps-Websites / Bug/Security / shield-lock"><g id="Group_71" data-name="Group 71">
      <g id="shield-lock"><path id="Shape_387" data-name="Shape 387" className="cls-2" d="M5.27,7.79V19.3A18,18,0,0,0,16.8,36.09l1.57.6a4.47,4.47,0,0,0,3.26,0l1.57-.6A18,18,0,0,0,34.73,19.3V7.79a2.24,2.24,0,0,0-1.31-2.06A32.76,32.76,0,0,0,20,3,32.76,32.76,0,0,0,6.58,5.73,2.24,2.24,0,0,0,5.27,7.79Z"/>
        <path id="Rectangle-path_25" data-name="Rectangle-path 25" className="cls-2" d="M13.2,18.86a2.27,2.27,0,0,1,2.27-2.26h9.06a2.27,2.27,0,0,1,2.27,2.26v6.8a2.27,2.27,0,0,1-2.27,2.27H15.47a2.27,2.27,0,0,1-2.27-2.27Z"/><path id="Shape_388" data-name="Shape 388" className="cls-2" d="M20,9.8h0a4.53,4.53,0,0,0-4.53,4.53V16.6h9.06V14.33A4.53,4.53,0,0,0,20,9.8Z"/>
        <path id="Shape_389" data-name="Shape 389" className="cls-2" d="M20,21.74a.57.57,0,1,1-.57.57.57.57,0,0,1,.57-.57"/>
      </g>
    </g>
    </g>
  </svg>
);

export const LuggageGlobe = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="size">
    <path className="cls-1" d="M23.4,23.38h4.53a2.27,2.27,0,0,1,2.27,2.27V41.52a2.27,2.27,0,0,1-2.27,2.27H23.4a0,0,0,0,1,0,0V23.38A0,0,0,0,1,23.4,23.38Z" transform="translate(60.38 6.79) rotate(90)"/>
    <g id="Travel_Travel-Metaphor_travel-luggage-1" data-name="Travel / Travel-Metaphor / travel-luggage-1">
      <g id="Group_2" data-name="Group 2"><g id="travel-luggage-1"><path id="Shape_7" data-name="Shape 7" className="cls-2" d="M10.92,29A13.6,13.6,0,1,1,30.2,16.6"/><path id="Shape_8" data-name="Shape 8" className="cls-2" d="M8,6.1l8,3a2.26,2.26,0,0,1,1.43,2.57l-.47,2.37a2.26,2.26,0,0,1-1.68,1.75l-3.14.79L10.32,21a4.52,4.52,0,0,1-1.7,2.09L5.86,25"/><path id="Shape_9" data-name="Shape 9" className="cls-2" d="M26,6.8l-2.21,4.42A2.28,2.28,0,0,0,23.69,13l.85,2.51"/><path id="Rectangle-path" className="cls-2" d="M16.6,26.8a2.27,2.27,0,0,1,2.26-2.27H34.73A2.27,2.27,0,0,1,37,26.8v7.93A2.27,2.27,0,0,1,34.73,37H18.86a2.27,2.27,0,0,1-2.26-2.27Z"/><path id="Shape_10" data-name="Shape 10" className="cls-2" d="M21.13,24.53V37"/>
        <path id="Shape_11" data-name="Shape 11" className="cls-2" d="M32.46,24.53V37"/>
        <path id="Shape_12" data-name="Shape 12" className="cls-2" d="M23.4,24.53V23.4a3.4,3.4,0,1,1,6.8,0v1.13"/>
      </g>
      </g>
    </g>
  </svg>
);

export const Sun = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="size">
    <title>{'sun'}</title>
    <path id="Oval_98" data-name="Oval 98" className="cls-1" d="M25.16,25.15a7.29,7.29,0,0,0-1.92-11.68,7.16,7.16,0,0,1-9.76,9.76,7.27,7.27,0,0,0,11.68,1.92Z"/>
    <g id="Interface-Essential_Controls_brightness" data-name="Interface-Essential / Controls / brightness">
      <g id="Group_162" data-name="Group 162"><g id="brightness"><path id="Oval_98-2" data-name="Oval 98" className="cls-2" d="M20,27.29A7.29,7.29,0,1,0,12.72,20,7.29,7.29,0,0,0,20,27.29Z"/>
        <path id="Shape_741" data-name="Shape 741" className="cls-2" d="M20,3V7.86"/>
        <path id="Shape_742" data-name="Shape 742" className="cls-2" d="M20,32.14V37"/>
        <path id="Shape_743" data-name="Shape 743" className="cls-2" d="M37,20H32.15"/>
        <path id="Shape_744" data-name="Shape 744" className="cls-2" d="M7.86,20H3"/>
        <path id="Shape_745" data-name="Shape 745" className="cls-2" d="M32,8l-3.44,3.43"/>
        <path id="Shape_746" data-name="Shape 746" className="cls-2" d="M11.42,28.58,8,32"/>
        <path id="Shape_747" data-name="Shape 747" className="cls-2" d="M32,32l-3.44-3.43"/>
        <path id="Shape_748" data-name="Shape 748" className="cls-2" d="M11.42,11.42,8,8"/>
      </g>
      </g>
    </g>
  </svg>
);

export const Tea = () => (
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" className="size">
    <title>{'tea'}</title>
    <path className="cls-1" d="M25.53,16.6H23.66A2.19,2.19,0,0,1,24,17.76v6.5A10.83,10.83,0,0,1,9.14,34.31,11.33,11.33,0,0,0,27.8,25.67v-6.8A2.26,2.26,0,0,0,25.53,16.6Z"/>
    <g id="Food-Drinks_Teas_tea-cup" data-name="Food-Drinks / Teas / tea-cup">
      <g id="Group_247" data-name="Group 247"><g id="Regular_247" data-name="Regular 247">
        <path id="Shape_1320" data-name="Shape 1320" className="cls-2" d="M7.4,16.6H25.53a2.26,2.26,0,0,1,2.27,2.27v6.8A11.34,11.34,0,0,1,16.47,37h0A11.34,11.34,0,0,1,5.13,25.67v-6.8A2.27,2.27,0,0,1,7.4,16.6Z"/>
        <path id="Shape_1321" data-name="Shape 1321" className="cls-2" d="M27.8,18.87h2.27a6.82,6.82,0,0,1,6.8,6.8h0a6.82,6.82,0,0,1-6.8,6.8H25.53"/>
        <path id="Shape_1322" data-name="Shape 1322" className="cls-2" d="M15.33,23.4V16.6"/>
        <path id="Shape_1323" data-name="Shape 1323" className="cls-2" d="M24.4,3C26.57,7.34,20,8.86,23.27,13.2"/>
        <path id="Shape_1324" data-name="Shape 1324" className="cls-2" d="M17.6,3c2.17,4.34-4.38,5.86-1.13,10.2"/>
        <path id="Shape_1325" data-name="Shape 1325" className="cls-2" d="M10.8,3C13,7.34,6.42,8.86,9.67,13.2"/>
        <path id="Rectangle-path_55" data-name="Rectangle-path 55" className="cls-2" d="M11.93,24.16a.76.76,0,0,1,.76-.76H18a.76.76,0,0,1,.75.76v5.28a.76.76,0,0,1-.75.76H12.69a.76.76,0,0,1-.76-.76Z"/>
      </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/universal/components/ValueProps/Icons/Icons.js